import { Component } from '@angular/core'
import { CoreService } from '../../../../services'
import { User } from 'depoto-core/src/entities'
import { Emittable, Emitter } from '@ngxs-labs/emitter'
import { PlugplayState } from '../../states/plugplay-state.service'
import { DialogService } from 'primeng/dynamicdialog'
import { TranslateService } from '@ngx-translate/core'
import { DeletionComponent } from '../../dialogs/deletion/deletion.component'

@Component({
  selector: 'app-step3',
  templateUrl: './step3.component.html',
  styleUrls: ['./step3.component.scss'],
})
export class Step3Component {
  @Emitter(PlugplayState.setActive)
  private readonly setActive: Emittable<number>
  @Emitter(PlugplayState.setHighestLastStepCompleted)
  public readonly setHighestLastStepCompleted: Emittable<number>
  @Emitter(PlugplayState.setHighestStepVisited)
  private readonly setHighestStepVisited: Emittable<number>
  public userList = []
  isLoading: boolean

  constructor(
    private core: CoreService,
    private dialogService: DialogService,
    private translateService: TranslateService,
  ) {
    this.setActive.emit(2)
    this.setHighestStepVisited.emit(2)
    this.load()
  }
  private load(): void {
    this.isLoading = true
    this.core.services.user
      .getList(
        { filters: { enabled: true }, page: 0, sort: 'id', direction: 'DESC' },
        {
          id: null,
          email: null,
          name: null,
          firstName: null,
          lastName: null,
          groups: {
            name: null,
          },
          deletable: null,
        },
      )
      .then(resp => {
        this.userList = resp?.items?.filter(user => this.core.services.user.user.id !== user.id) || []
        this.isLoading = false
      })
  }

  public delete(id): void {
    this.core.services.user.delete(new User({ id })).then(_ => this.load())
  }
}
